var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1009 210.8",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#101332;}.cls-4{fill:#08dadb;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:#3968fe;}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:#6a45eb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 141.12,
    y1: 204.19,
    x2: 84.1,
    y2: 204.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6a45eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#6a45eb",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6a45eb",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6a45eb",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6a45eb",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6a45eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 70.57,
    y1: 210.31,
    x2: 70.57,
    y2: 99.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#08dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#08dadb",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#08dadb",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#08dadb",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#08dadb",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#08dadb",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#08dadb",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#08dadb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 93.55,
    y1: 45.99,
    x2: 93.55,
    y2: 110.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6a45eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6a45eb",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#6a45eb",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6a45eb",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6a45eb",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6a45eb",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6a45eb",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6a45eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 141.12,
    y1: 6.61,
    x2: 84.1,
    y2: 6.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#08dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#08dadb",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#08dadb",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#08dadb",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#08dadb",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.65,129.67a25.26,25.26,0,0,1-15.92,5.18,26.23,26.23,0,0,1-19.83-8.38q-8-8.39-8-21t8-21.11A26.14,26.14,0,0,1,260.73,76a25.58,25.58,0,0,1,15.43,4.79,26.66,26.66,0,0,1,9.56,13.15H306a45.09,45.09,0,0,0-15.76-26.95q-12.5-10.3-29.52-10.3a49,49,0,0,0-19.08,3.75A46.55,46.55,0,0,0,226.29,70.6a47.13,47.13,0,0,0-10.11,15.52,50.59,50.59,0,0,0-3.72,19.38,50,50,0,0,0,3.72,19.21,47.1,47.1,0,0,0,10.11,15.49,46.55,46.55,0,0,0,15.36,10.21,49,49,0,0,0,19.08,3.75q17.36,0,29.88-10.63t15.72-28H285.91A26.36,26.36,0,0,1,276.65,129.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.7,83.09a39.46,39.46,0,0,0-38.59-.16,35.33,35.33,0,0,0-13.44,13.7,41,41,0,0,0,0,38.81,35.75,35.75,0,0,0,13.47,13.73,38.94,38.94,0,0,0,41.26-1.95A36.66,36.66,0,0,0,388,128.46H367.53a15.77,15.77,0,0,1-6.23,6.13,18.37,18.37,0,0,1-9,2.22,17.57,17.57,0,0,1-11.77-3.94c-3.12-2.64-5.08-6.41-5.91-11.32h54.6a40.19,40.19,0,0,0,.4-5.74,39.42,39.42,0,0,0-4.64-19A35.06,35.06,0,0,0,371.7,83.09Zm-36.6,25.15a18.34,18.34,0,0,1,6.2-10,17,17,0,0,1,11-3.59,17.87,17.87,0,0,1,11.19,3.53,19.5,19.5,0,0,1,6.62,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.5,78.15A32.18,32.18,0,0,0,431,81a29.22,29.22,0,0,0-10.4,7.79l-3.79-10H403.47v75.4H423V114.1q0-8.75,4.33-13.8c2.9-3.37,6.84-5.06,11.85-5.06q12.58,0,12.59,16.18v42.74h19.5V108.29q0-13.77-7.24-22T444.5,78.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.87,87.64l-3.46-8.88H546v75.4h19.5V113.4q0-8.87,3.56-12.75t11.77-3.88h8.42V78.37h-6.39Q569.29,78.37,561.87,87.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M655.42,86.78A34.43,34.43,0,0,0,631.73,78a38.56,38.56,0,0,0-19.37,4.92,35.23,35.23,0,0,0-13.57,13.64,38.92,38.92,0,0,0-4.89,19.41,39.47,39.47,0,0,0,4.89,19.54,35.39,35.39,0,0,0,13.57,13.73,38.38,38.38,0,0,0,19.37,4.95,34.33,34.33,0,0,0,23.36-8.61l1.7,6.46h15.33V79.86H657.5Zm-8.06,43.31a20.38,20.38,0,0,1-28.12,0,20.67,20.67,0,0,1,0-28.25,20.38,20.38,0,0,1,28.12,0,19.25,19.25,0,0,1,5.58,14.16A19.24,19.24,0,0,1,647.36,130.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M756.27,112.35a16.1,16.1,0,0,0-2.84-4.37,39.5,39.5,0,0,0-3.45-3.49,22,22,0,0,0-4.28-2.81q-2.67-1.4-4.5-2.22a48.19,48.19,0,0,0-5-1.79q-3.13-1-4.87-1.44T726.46,95c-2.52-.6-4.45-1.08-5.77-1.43S717.78,92.7,716,92a18.31,18.31,0,0,1-4.11-2,9.11,9.11,0,0,1-2.38-2.55,6.17,6.17,0,0,1-1-3.45,7.23,7.23,0,0,1,3.89-6.59,17.9,17.9,0,0,1,9.29-2.29,16.49,16.49,0,0,1,10.15,3q4.07,3,4.07,8.77h20q0-14.09-8.84-22.08t-24.89-8q-15.72,0-24.82,7.34t-9.1,20.64a31.32,31.32,0,0,0,.26,4.05q1.57,12.33,14,18.26,5.22,2.55,17,5.42c2.22.52,3.89.92,5,1.21s2.54.68,4.28,1.2a18.75,18.75,0,0,1,3.94,1.57,27.7,27.7,0,0,1,2.81,1.89,6.47,6.47,0,0,1,2.09,2.54,8.08,8.08,0,0,1,.62,3.2,9.23,9.23,0,0,1-4.5,8,18.65,18.65,0,0,1-10.57,3,18,18,0,0,1-11.22-3.49q-4.58-3.49-4.57-9.95H686.93q0,14.87,10,23.52T723.2,154a48.74,48.74,0,0,0,13.73-1.86,35.14,35.14,0,0,0,11.22-5.48,25.11,25.11,0,0,0,7.67-9.43,29.89,29.89,0,0,0,2.8-13.17,29.08,29.08,0,0,0-.68-6.4A30.45,30.45,0,0,0,756.27,112.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M804.29,123.27,785,78.91h-21.2l30.53,66.6-.26.59q-3.39,8.35-6.36,10.9t-9.88,2.54h-6.79v17.55h8a31.22,31.22,0,0,0,13.76-2.77,27.87,27.87,0,0,0,10-8.42,80.74,80.74,0,0,0,8.77-15.82L843,78.91H822.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M893.86,78.15A32.12,32.12,0,0,0,880.39,81,29.17,29.17,0,0,0,870,88.78l-3.78-10H852.82v75.4h19.51V114.1q0-8.75,4.34-13.8t11.84-5.06q12.59,0,12.59,16.18v42.74h19.5V108.29q0-13.77-7.24-22T893.86,78.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M989.36,123.76a20.18,20.18,0,0,1-7,8.94A17.79,17.79,0,0,1,972,135.83a17.24,17.24,0,0,1-13.18-5.77,20,20,0,0,1-5.35-14.12,19.66,19.66,0,0,1,5.31-14A17.43,17.43,0,0,1,972,96.3a18.9,18.9,0,0,1,10.43,3,18.33,18.33,0,0,1,7,8.32h19.38a35.75,35.75,0,0,0-12.69-21.5Q986,78,972.08,78a40.17,40.17,0,0,0-15.24,2.9,37.07,37.07,0,0,0-12.23,7.93,36.32,36.32,0,0,0-8,12.07,38.54,38.54,0,0,0-2.94,15,39,39,0,0,0,2.94,15.07,36.89,36.89,0,0,0,8,12.2,37.46,37.46,0,0,0,12.2,8.06,38.89,38.89,0,0,0,15.14,3,37.09,37.09,0,0,0,24.3-8.38,36.12,36.12,0,0,0,12.75-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.43,133.94q-2.86-2.87-2.87-8.15V98.23h17V78.58H512.63v-22l-19.31,5.84V78.58h-13V98.23h12.77V128.4q0,12,6.88,18.88t18.75,6.88h13.83V136.81h-8.87C520.08,136.81,517.34,135.86,515.43,133.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.9,205.22a8,8,0,0,0,2.22,5.57H105.4c-3.43,0-6.88-.17-10.27-.48l-.51-.05a105.47,105.47,0,0,1-10.45-1.61H84.1l1.67-11.06a90.76,90.76,0,0,0,11,1.67c2.83.25,5.71.39,8.6.39h35.72A8,8,0,0,0,138.9,205.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147,176.67a5.27,5.27,0,0,0-.57,0,1.35,1.35,0,0,1,.29,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.98,
    cy: 182.24,
    r: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.14,176.66H105.4c-1.72,0-3.45,0-5.15-.19a70.26,70.26,0,0,1-11-1.65A71.45,71.45,0,0,1,34.35,111c-.13-1.84-.22-3.7-.22-5.57s.09-3.73.22-5.57H23.17c-.11,1.85-.18,3.71-.18,5.57s.07,3.71.18,5.57a86.27,86.27,0,0,0,1.49,11,82.87,82.87,0,0,0,4.81,15.48,81.69,81.69,0,0,0,17.67,26.18,82.31,82.31,0,0,0,26.18,17.66,83.59,83.59,0,0,0,14.23,4.55l-1.78,11.71A94.44,94.44,0,0,1,11.31,111c-.1-1.84-.15-3.7-.15-5.57s.05-3.73.15-5.57H.15c-.1,1.85-.15,3.71-.15,5.57s.05,3.71.15,5.57.22,3.48.4,5.19a104.92,104.92,0,0,0,1.59,10.47A105.55,105.55,0,0,0,18,164.34a108,108,0,0,0,12.87,15.6,106.57,106.57,0,0,0,15.6,12.85A105,105,0,0,0,84.1,208.65h.07a105.47,105.47,0,0,0,10.45,1.61l.51.05,1.67-11.05,1.77-11.73c2.28.19,4.55.29,6.83.29h35.74a8.07,8.07,0,0,1,0-11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.12,46H105.4c-1.12,0-2.24,0-3.36.1a60,60,0,0,0-8.6,1.1c-.82.17-1.63.36-2.43.56a59,59,0,0,0-18.84,8.4,59.67,59.67,0,0,0-8.79,7.24,61,61,0,0,0-7.24,8.79,59.81,59.81,0,0,0-5.49,10.1,59.14,59.14,0,0,0-3.46,11.16,61.65,61.65,0,0,0-.94,6.4c-.18,1.84-.27,3.71-.27,5.57s.09,3.71.27,5.57H57.44a50.2,50.2,0,0,1,0-11.14,48.4,48.4,0,0,1,35.26-41,47.62,47.62,0,0,1,11-1.67c.57,0,1.12,0,1.69,0h35.72a8.1,8.1,0,0,1,0-11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.4,153.67c-.57,0-1.12,0-1.69,0a47.62,47.62,0,0,1-11-1.67,48.45,48.45,0,0,1-35.26-41,50.2,50.2,0,0,1,0-11.14H34.35A71.41,71.41,0,0,1,89.24,36a70.28,70.28,0,0,1,11-1.67c1.7-.12,3.43-.19,5.15-.19h35.72a8.1,8.1,0,0,1,0-11.14H105.4c-2.28,0-4.55.1-6.83.28L96.8,11.55,95.13.51l-.51.05A105.41,105.41,0,0,0,84.17,2.15a.1.1,0,0,1-.07,0A104.46,104.46,0,0,0,46.47,18,105.44,105.44,0,0,0,8.3,64.38,103.86,103.86,0,0,0,.55,94.63c-.18,1.73-.3,3.47-.4,5.21S0,103.55,0,105.41s.05,3.71.15,5.57h46.1a61.86,61.86,0,0,0,.94,6.39,58.71,58.71,0,0,0,9,21.25,59.23,59.23,0,0,0,16,16,59.42,59.42,0,0,0,10.11,5.47A58.13,58.13,0,0,0,91,163.07q1.2.3,2.43.54a60,60,0,0,0,8.6,1.12c1.12.06,2.24.1,3.36.1h35.74a8.07,8.07,0,0,1,0-11.16ZM24.66,88.81a86,86,0,0,0-1.49,11H11.31A94.46,94.46,0,0,1,85.77,13.21l1.78,11.73a81.78,81.78,0,0,0-14.23,4.53A82.55,82.55,0,0,0,29.47,73.33,82.64,82.64,0,0,0,24.66,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.12,0H105.4C102,0,98.52.18,95.13.51l-.51.05A105.41,105.41,0,0,0,84.17,2.15a.1.1,0,0,1-.07,0l1.67,11a97,97,0,0,1,11-1.66c2.83-.26,5.71-.4,8.6-.4h35.72a8.1,8.1,0,0,1,0-11.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 146.98,
    cy: 159.25,
    r: 5.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 146.98,
    cy: 51.56,
    r: 5.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 146.98,
    cy: 28.57,
    r: 5.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.98,
    cy: 5.58,
    r: 5.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 146.98,
    cy: 205.22,
    r: 5.58
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/Logo-dark.0ecbe9dfffa97c1568db781b7728d5ac.svg";
export { ForwardRef as ReactComponent };